export default __webpack_public_path__ + "static/1950_1960-ee44b29f3be76239bf57b58daed87f9b.jpg";